import { experimentsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

/**
 * `POST /experiments/{id}/stop` — operator-initiated halt of a running
 * experiment. Two outcomes per the State-Transitions spec:
 *  - `finalStatus: CANCELLED` — abort the run (results discarded as
 *    incomplete).
 *  - `finalStatus: COMPLETED` — mark as finished early (use when the
 *    operator has enough signal sooner than the planned duration).
 *
 * Server returns 409 if the experiment is already terminal
 * (`status ∈ { CANCELLED, COMPLETED }`); 4xx for an unknown id.
 */
export type ExperimentStopFinalStatus = 'CANCELLED' | 'COMPLETED';

export interface ExperimentStopPayload {
  finalStatus: ExperimentStopFinalStatus;
  /**
   * Free-form audit string carried alongside the terminal transition.
   * Required per the State-Transitions reference — call sites set a
   * deterministic value per CTA (e.g. "Ended without scaling") or fall
   * through to whatever the operator types in the confirm dialog.
   */
  reason: string;
}

export async function stopExperiment(expId: string, payload: ExperimentStopPayload): Promise<void> {
  await experimentsClient.post(endpoints.experiments.stop(expId), { json: payload });
}
